<template>
  <TaskView label="Image Cache" import-title="Cache Images" count-label="Images Cached" task-name="cacheListingImages" :city="city">
    <template #description>
      All of the listings' relevant images exist on other vendors' sites. To improve the performance of our
      matching algorithms, we can download the images to our site.
    </template>
  </TaskView>
  <DefaultListingValuesCard :city-id="city.id"/>
</template>

<script>
import {City} from "@/models/City";
import TaskView from "@/components/admin-city/TaskView.vue";
import DefaultListingValuesCard from "@/components/admin-city/listings/DefaultListingValuesCard.vue";

export default {
  components: {DefaultListingValuesCard, TaskView},
  props: {
    city: City
  }
}
</script>
